<template>
	<div class="head" :style="{marginLeft:`${marginLeft}`}">
		<div class="headContent">
			<div class="logo">
				<span>语之乐优课</span>
			</div>
			<!-- <div>
				<div class="bubble">官方补贴</div>
			</div> -->
			<div class="menu">
				<router-link :class="'home'===selUrl?'aSel':''" to="/">首页</router-link>
				<router-link v-for="item in menuList" :key="item.id" :style="{display:item.name==='定制课程'?'none':'block'}"
					:class="item.url===selUrl?'aSel':''" :to="`/${item.url}`">{{ item.name }}</router-link>
				<button v-if="!userInfo.token" type="button" @click="showLogin()">登录</button>
				<div v-else class="center">
					<div class="enter">
						<img class="bg" v-if="userInfo.avatar" :src="userInfo.avatar" alt="avatar" />
						<img class="bg" v-else src="@/assets/auth/logo.png" alt="avatar" />
						<span>{{ userInfo.nickname || '个人中心' }}</span>
					</div>
					<div class="listBox">
						<div class="list">
							<p @click="toMyPage('myOrder')">我的订单</p>
							<p @click="toMyPage('myCourse')">我的课程</p>
							<p @click="toMyPage('myCollect')">我的收藏</p>
							<p @click="toMyPage('myPartner')">我的团队</p>
							<p @click="loginOut">退出登录</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<LoginDialog ref="loginRef" @onSuccess="loginSuccess" @onClose="loginClose" />
	</div>
</template>
<script>
	import LoginDialog from "./loginDialog.vue";
	import moment from "moment/moment";

	export default {
		name: "HeaderRow",
		components: {
			LoginDialog,
		},
		data() {
			return {
				menuList: [],
				userInfo: this.$store.state.auth,
				marginLeft: 0
			};
		},
		props: {
			selUrl: {
				type: String,
				required: true,
			},
		},
		watch: {
			userInfo: {
				immediate: true,
				handler() {
					console.log("watch userInfo => ", this.$store.state.auth);
					this.userInfo = this.$store.state.auth;
				}
			}
		},
		async created() {
			const menuListInfo = JSON.parse(localStorage.getItem("menuList"));
			console.log("menuListInfo => ", menuListInfo);
			if (
				menuListInfo &&
				menuListInfo.version === moment(Date.now()).format("YYYY-MM-DD")
			) {
				this.menuList = menuListInfo.data;
			} else {
				const menusRes = await this.$zkHttp.index$menus();
				console.log("menusRes", menusRes);
				this.menuList = menusRes || [];
				this.$store.commit("menu/setMenuList", {
					...menusRes,
				});
			}
		},
		mounted() {
			const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
			this.marginLeft = `-${scrollLeft}px`;
			window.addEventListener('scroll', this.handleScroll);
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			handleScroll() {
				const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
				// console.log('实际滚动值:', scrollLeft);
				this.marginLeft = `-${scrollLeft}px`;
			},
			showLogin() {
				this.$refs.loginRef.onOpen();
			},
			loginSuccess() {
				this.$refs.loginRef.onClose();
			},
			loginClose() {
				this.$refs.loginRef.onClose();
			},
			loginOut() {
				this.$confirm('是否确认退出登录?', '温馨提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					console.log("loginOut => 确认");
					this.$store.commit("auth/setLoginOut", {});
					this.$message({
						message: "已退出登录",
						type: "success", // message type: success/warning/info/error
					});
					window.location.reload();
				});
			},
			toMyPage(page) {
				this.$router.push(`/${page}`);
			},
			doSomething() {
				this.$message({
					message: "In Developing...",
					type: "warning", // message type: success/warning/info/error
				});
			}
		}
	};
</script>
<style scoped lang="scss">
	* {
		margin: 0;
		padding: 0;
	}

	.bubble {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 2px solid #E23A4A;
		border-radius: 14px;
		border-bottom-left-radius: 0;
		background-color: #FA0A20;
		font-size: 28px;
		color: #fff;
		font-family: serif;
		font-weight: 600;
		position: relative;

		&::before {
			position: absolute;
			content: '';
			right: 100%;
			bottom: -2px;
			transform: rotateY(180deg);
			background: repeating-linear-gradient(to right, #FA0A20, #E23A4A 100%);
			width: 12px;
			height: 18px;
			box-sizing: border-box;
			clip-path: polygon(0 0, 0% 100%, 100% 100%);
		}

		&::after {
			position: absolute;
			content: '';
			right: calc(100% - 2px);
			bottom: 0;
			transform: rotateY(180deg);
			background-color: #FA0A20;
			width: 12px;
			height: 14px;
			box-sizing: border-box;
			clip-path: polygon(0 0, 0% 100%, 100% 100%);
		}
	}

	.head {
		width: 100%;
		min-width: 1280px;
		position: fixed;
		top: 0;
		z-index: 99;
		background: #fff;
		box-shadow: 0 0 10px 0 #f1f1f1;
		display: flex;
		justify-content: center;
		align-items: center;

		.headContent {
			width: 1280px;
			height: 60px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.logo span {
				padding: 0 10px;
				font-size: 32px;
				color: #e4395b;
				font-weight: bold;
				font-family: cursive;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.menu {
				display: flex;
				flex-direction: row;
				justify-content: flex-end;
				align-items: center;

				>a {
					margin-left: 40px;
					font-size: 18px;
					color: #333;
					font-weight: normal;
					line-height: 56px;
					border-bottom: 4px solid #fff;
					cursor: pointer;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.aSel {
					color: #0fa784;
					border-bottom: 4px solid #0fa784;
				}

				button {
					cursor: pointer;
					display: flex;
					justify-content: center;
					align-items: center;
					background: #fff;
					border: 1px solid #12cc9f;
					border-radius: 15px;
					height: 30px;
					width: 68px;
					margin-left: 60px;
					margin-right: 10px;
					font-size: 14px;
					color: #0fa784;
				}

				.center:hover {
					.listBox {
						display: block;
					}
				}

				.center {
					cursor: pointer;
					display: flex;
					justify-content: center;
					align-items: center;
					background: #fff;
					border: 1px solid #12cc9f;
					border-radius: 15px;
					//min-width: 68px;
					height: 30px;
					padding: 0 12px;
					margin-left: 60px;
					margin-right: 10px;
					position: relative;

					.enter {
						width: max-content;
						display: flex;
						flex-direction: row;
						justify-content: center;
						align-items: center;

						>img {
							width: 24px;
							height: 24px;
							border-radius: 12px;
							background: transparent;
							margin-right: 10px;
						}

						>span {
							font-size: 14px;
							color: #0fa784;
						}
					}

					.listBox {
						position: absolute;
						top: 28px;
						//right: 0;
						background: transparent;
						display: none;
						cursor: default;
						padding: 10px 0;

						.list::before {
							content: "";
							display: block;
							width: 0;
							height: 0;
							border-style: solid;
							border-width: 0 6px 10px 6px;
							border-color: transparent transparent #fff transparent;
							position: relative;
							top: -9px;
						}

						>.list {
							padding-bottom: 10px;
							width: 120px;
							background: #fff;
							border-radius: 10px;
							border: 1px solid #f1f1f1;
							box-shadow: 1px 2px 8px 0 #0fa784;

							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;

							>p {
								margin: 2px 0;
								width: 100%;
								cursor: pointer;
								font-size: 14px;
								color: #333;
								line-height: 28px;
								border-bottom: 1px solid #f1f1f1;
								text-align: center;
							}

							>p:last-child {
								border-top: 1px solid #f1f1f1;
								border-bottom: none;
								color: #0fa784;
							}
						}
					}
				}
			}
		}
	}
</style>